import React from 'react';

import Icon from '~/core/scripts/components/Icon';

const DropdownIndicator = ({ hasValue, getValue, selectOption }) => {
  const onClick = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    if (hasValue) {
      selectOption(getValue()[0]);
    }
  }

  return (
    <button
      className="btn btn-search"
      onTouchEnd={onClick}
      onMouseDown={onClick}
    >
      <Icon type="search" />
    </button>
  );
};

DropdownIndicator.displayName = 'DropdownIndicator';

export default DropdownIndicator;
